const PDFJS_VERSION = '4.8.69';
const PDFJS_CDN = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VERSION}`;

/**
 * @returns {boolean}
 */
const isIOSDevice = () => {
  const ua = navigator.userAgent;
  const isIOSUA = /iPad|iPhone|iPod/.test(ua);
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  return isIOSUA || isIPadOS;
};

if (!customElements.get('pdf-viewer')) {
  customElements.define(
    'pdf-viewer',
    class PdfViewer extends HTMLElement {
      /** @type {boolean} */
      #rendered = false;

      connectedCallback() {
        if (!isIOSDevice() || this.#rendered) return;

        this.#rendered = true;
        this.#renderVerticalPages();
      }

      get frame() {
        return this.querySelector('.pdf-viewer-section__frame');
      }

      get pagesContainer() {
        return this.querySelector('.pdf-viewer-section__pages');
      }

      async #renderVerticalPages() {
        const pdfUrl = this.dataset.pdfUrl;
        const pagesContainer = this.pagesContainer;

        if (!pdfUrl || !pagesContainer) return;

        this.classList.add('pdf-viewer-section--ios');
        pagesContainer.hidden = false;

        try {
          const pdfjs = await import(`${PDFJS_CDN}/pdf.min.mjs`);
          pdfjs.GlobalWorkerOptions.workerSrc = `${PDFJS_CDN}/pdf.worker.min.mjs`;

          await new Promise((resolve) => requestAnimationFrame(resolve));

          const pdf = await pdfjs.getDocument(pdfUrl).promise;
          const containerWidth = this.parentElement?.clientWidth || this.clientWidth || pagesContainer.clientWidth || window.innerWidth;
          const pixelRatio = window.devicePixelRatio || 1;

          for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
            const page = await pdf.getPage(pageNumber);
            const unscaledViewport = page.getViewport({ scale: 1 });
            const scale = containerWidth / unscaledViewport.width;
            const viewport = page.getViewport({ scale: scale * pixelRatio });

            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            if (!context) continue;

            canvas.width = viewport.width;
            canvas.height = viewport.height;
            canvas.style.width = `${viewport.width / pixelRatio}px`;
            canvas.style.height = `${viewport.height / pixelRatio}px`;

            await page.render({
              canvasContext: context,
              viewport,
            }).promise;

            pagesContainer.appendChild(canvas);
          }
        } catch (error) {
          console.error('PDF viewer failed to render on iOS:', error);
          pagesContainer.hidden = true;
          pagesContainer.replaceChildren();
        }
      }
    }
  );
}
